import { Outlet } from "react-router-dom";

import { useFormationAccess } from "./access";

export function FormationLayout() {
  const { access } = useFormationAccess();

  if (!access) {
    return <div className="panel p-6"><h1 className="text-xl font-bold">Formation</h1><p className="mt-2 text-sm text-slate-500">Le module n’est pas disponible pour cette organisation.</p></div>;
  }

  return <div className="formation-ui"><Outlet /></div>;
}
